<div>
    <ng-template hsDialogHost></ng-template>
</div>
